<template>

  <div class="vl-parent">
        <loading v-model:active="isLoading"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="fullPage"/>
    </div>
      <div class="container mb-0 pt-0 mt-60">
        <div class="section-content">
          <div class="row mt-10">
            <form class="fed_search" @submit.prevent="searchfederation()">
              <div class="form-group col-md-4">
                <label for="">Federation Name</label>
                <input type="text" class="form-control" v-model="federation" @input="searchInput"   placeholder="Federation Name">
               <div class="productlist" v-if="federationok" ref="suggestionsList">
                <ul>
                 <li @click="selectfederation(federation.FederationName)" v-for="federation in this.federationlist">{{federation.FederationName}}</li>
                 </ul>
               </div>
              </div>
              <div class="form-group col-md-3">
                 <label for="">District</label>
                <input type="text" class="form-control" v-model="district" @input="districtInput"  placeholder="District Name">
                <div class="productlist2" v-if="districtok" ref="suggestionsList2">
                <ul>
                 <li @click="selectdistrict(district.District)" v-for="district in this.districtlist">{{district.District}}</li>
                 </ul>
               </div>
              </div>
              <div class="form-group col-md-3">
                 <label for="">Upazila</label>
                <input type="text" class="form-control" v-model="upazila" @input="upazilaInput"  placeholder="Upazila Name">
                <div class="productlist3" v-if="upazilaok" ref="suggestionsList3">
                <ul>
                 <li @click="selectupazila(upazila.Upazila)" v-for="upazila in this.upazilalist">{{upazila.Upazila}}</li>
                 </ul>
               </div>
              </div>
               <div class="form-group col-md-2">
                <button type="submit" class="fed_search_btn"><i class="fa fa-search"></i> Search</button>
              </div>
            </form>

          </div>
          <div class="row mt-10">
           <h3 style="background: #ED1C24; padding: 10px; line-height: 42px; text-align: center; color: #fff;">Federation General Information</h3>
            <div class="table-responsive"> 
              <table class="table table-bordered"> 
                <thead> 
                  <tr> 
                    <th style="width:20px!important;">Sl.&nbsp;No.</th> 
                    <th>Federation&nbsp;Name</th> 
                    <th>District</th> 
                    <th>Upazila</th> 
                    <th>Village</th> 
                    <th>Post&nbsp;Office</th> 
                    <th>Formation&nbsp;Year</th>
                    <th>Female&nbsp;Headed</th>
                    <th>Federation Chairman Name&nbsp; / Mobile&nbsp;number</th>
                    <th>More&nbsp;Details</th>
                  </tr> 
                </thead> 
                <tbody> 
                  <tr v-for="(federation,index) in this.generalinformations"> 
                    <td style="width:20px!important;">{{index+1}}</td> 
                    <td>{{federation.FederationName}}</td> 
                    <td>{{federation.District}}</td> 
                    <td>{{federation.Upazila}}</td> 
                    <td>{{federation.Village}}</td> 
                    <td>{{federation.PostOffice}}</td> 
                    <td>{{federation.FederationFormationYear}}</td> 
                    <td>{{federation.FemaleHeaded}}</td> 
                    <td>{{federation.NameofCurrentFederationChairman}}<br>{{federation.MobilenumberofCurrentFederationChairman  }}</td> 
                    <td><a class="action_next" :href="url+'federationdetails/'+federation.id"><i class="fa fa-eye" aria-hidden="true"></i></a></td> 
                  </tr> 
                </tbody> 
              </table> 
            </div>

          </div>
        </div>
      </div>
</template>
<script>
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default{

  props:['federationid'],
  components: {
    Loading
  },
  data(){
    return{
     generalinformations:[],
     searchproduct:'',
     federationlist:[],
     federationok:false,
     suggestion:false,
     federation:'',
     district:'',
     districtok:false,
     districtlist:[],
     upazilaok:false,
     upazilalist:[],
     upazila:'',
     isLoading: false,
     fullPage: true
    }
  },
  computed:{
    url(){
      return this.$store.state.url;
    }
   
  },
  
  created(){
    console.log(this.federationid);
    this.getallfederations();
    document.addEventListener('click', this.pageClick);
  },
  beforeUnmount() {
      document.removeEventListener('click', this.pageClick);
  },
  methods:{
  searchfederation(){
      this.isLoading = true;
      if(this.federation=='' && this.district=='' && this.upazila==''){
        toast.warning("Please insert at least one input field!", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });
        this.isLoading = false;
      }else{
        axios.post(this.url+'searchfederation',{
          federation:this.federation,
          district:this.district,
          upazila:this.upazila

        }).then(response=>{

           setTimeout(() => {
           this.isLoading = false;
           this.generalinformations=response.data;
           this.federation='';
           this.district='';
           this.upazila='';
           },1000)


        })

      } 
  },
  pageClick(event){
      if (
           event.target !== this.$refs.inputField &&
           event.target !== this.$refs.suggestionsList &&
           event.target !== this.$refs.suggestionsList2 &&
           event.target !== this.$refs.suggestionsList3 
           ) {
            this.federationok = false;
            this.districtok=false;
            this.upazilaok=false;
            this.suggestion=false;
            this.suggestion2=false;
            this.suggestion3=false;
   }
   },
   searchInput(event){
      var federationname=event.target.value;
      if(federationname==''){
      this.federationlist=[];
      }else{
        axios.get(this.url+'getfederationlist/'+federationname).then(response=>{
                this.federationlist=response.data;
         console.log(this.federationlist);
        })
        this.federationok=true;

      }

    },
    districtInput(event){
      var districtname=event.target.value;
      if(districtname==''){
      this.districtlist=[];
      }else{
        axios.get(this.url+'getdistrictlist/'+districtname).then(response=>{
                this.districtlist=response.data;
         console.log(this.districtlist);
        })
        this.districtok=true;

      }

    },
    upazilaInput(event){
      var upazila=event.target.value;
      if(upazila==''){
      this.upazila=[];
      }else{
        axios.get(this.url+'getupazila/'+upazila).then(response=>{
                this.upazilalist=response.data;
         console.log(this.upazila);
        })
        this.upazilaok=true;

      }

    },
    selectfederation(federationname){

      this.federation=federationname;

    },
    selectdistrict(districtname){
      this.district=districtname;
    },
    selectupazila(upazila){
      this.upazila=upazila;
    },
    getallfederations(){
    axios.get(this.url+'getfederation/'+this.federationid).then(response=>{
      this.generalinformations=response.data;
      console.log(this.generalinformations);
     });
   }
    
  }

}
</script>
<style scoped>
  .fed_search_btn {
    background: red;
    position: relative;
    top: 37px;
    padding: 8px 30px;
    line-height: 30px;
    border: 0px;
    width: 100%;
}
 .productlist,.productlist2,.productlist3
  {
    position: absolute;
    background: #333;
    color: white;
    width: 100%;
    z-index: 999999;
  }
  .productlist ul,.productlist2 ul,.productlist3 ul{
    list-style: none;
    background: rgb(237, 28, 36);
  }
  .productlist ul li,.productlist2 ul li,.productlist3 ul li{
    border-bottom: 1px solid white;
    padding:5px;
    cursor: pointer;
  }

  .pre-loader {
  padding: 10px;
  background-color: #f1f1f1;
  /* Add more styles as needed */
  }
  </style>
